<template>
  <div class="container">
    <div style="margin: 10px 10px 10px 10px;">
      <el-row>
        <el-col :span="18">
          <el-button type="warning" @click="createShop">新增商店</el-button>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="Search" v-model="filters[0].value"></el-input>
        </el-col>
      </el-row>
    </div>

    <data-tables
      :data="tableData"
      :pagination-props="{ pageSizes: [15, 25, 50] }"
      :filters="filters"
      :table-props="tableProps"
    >
      <el-table-column label="商店ID" prop="accountId" sortable="custom" min-width="15px">
        <template slot-scope="scope">{{scope.row.accountId}}</template>
      </el-table-column>
      <el-table-column label="商店名稱" prop="name" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column label="商店狀態" prop="isInitializedForSort" sortable="custom" min-width="30px">
        <template slot-scope="scope">
          <el-popover
            placement="right"
            trigger="click">
            <el-radio-group v-model="scope.row.isInitialized.text" @change="changeInitailizedStatus(scope.row)">
              <el-radio-button label="未上線"></el-radio-button>
              <el-radio-button label="已上線"></el-radio-button>
            </el-radio-group>

            <el-button size="small" slot="reference">{{scope.row.isInitialized.text}}</el-button>
          </el-popover>

        </template>
      </el-table-column>
      <el-table-column label="所屬SI" prop="siAccountName" sortable="custom" min-width="20px">
        <template slot-scope="scope">
          <el-popover
            placement="right"
            trigger="click">
            <el-select
              class="select-primary"
              size="large"
              placeholder="Single Select"
              v-model="scope.row.siAccountId"
              @change="selectChange(scope.row)"
            >
              <el-option
                v-for="option in siAccounts"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
            <el-button size="small" slot="reference">{{scope.row.siAccountName}}</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="所屬EAA" prop="name" sortable="custom" min-width="40px">
        <template slot-scope="scope" v-if="scope.row.eaaAccountEmail">{{scope.row.eaaAccountName}} &lt;{{scope.row.eaaAccountEmail}}></template>
      </el-table-column>
      <el-table-column label="統編" prop="invoice" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.invoice}}</template>
      </el-table-column>
      <el-table-column label="Actions" min-width="40px">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">商店參數</div>
            <n-button type="info" size="sm" icon @click.native="clickInfo(scope.row)">
              <i class="now-ui-icons users_single-02"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">修改商店設定</div>
            <n-button type="success" size="sm" icon @click.native="clickEdit(scope.row)">
              <i class="now-ui-icons ui-2_settings-90"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">桌號QRCode管理</div>
            <n-button type="warn" size="sm" icon @click.native="clickQR(scope.row)">
              <font-awesome-icon icon="qrcode" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">訂單推播群組設定</div>
            <n-button type="warning" size="sm" icon @click.native="lineNotifySetting(scope.row)">
              <i class="now-ui-icons ui-1_bell-53"></i>
            </n-button>
          </el-tooltip>
          <!-- <el-tooltip placement="top">
            <div slot="content">前往訂單列表</div>
            <n-button type="primary" size="sm" icon @click.native="goToOrderList(scope.row)">
              <font-awesome-icon icon="receipt" />
            </n-button>
          </el-tooltip>-->
          <el-tooltip placement="top">
            <div slot="content">合約管理</div>
            <n-button type="primary" size="sm" icon @click.native="clickContract(scope.row)">
              <font-awesome-icon icon="file-signature" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">營業公休設定</div>
            <n-button
              type="default"
              style="background:#A25DDC;"
              size="sm"
              icon
              @click.native="openingSetting(scope.row)"
            >
              <i class="now-ui-icons ui-1_calendar-60"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">接單機使用者管理</div>
            <n-button
              type="danger"
              style="background:#BA0000;"
              size="sm"
              icon
              @click.native="showQcposUsers(scope.row)"
            >
              <font-awesome-icon icon="tablet-alt" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">優惠活動設定</div>
            <n-button
              type="danger"
              style="background:#3b36ea;"
              size="sm"
              icon
              @click.native="promotions(scope.row)"
            >
              <font-awesome-icon icon="parachute-box" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">寄送週報表</div>
            <n-button type="warn"
              style="background:#191970;"
              size="sm"
              icon
              @click.native="showSendReportDialog(scope.row)"
            >
              <i class="el-icon-message"></i>
            </n-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </data-tables>

    <el-dialog
      :title="'接單機介面 - 使用者管理｜' + dialogs.qcposUsers.shop.name"
      width="40%"
      :visible.sync="dialogs.qcposUsers.show">
      <PosUserMngmt user-type="gaa" :shop-id="dialogs.qcposUsers.shop.accountId" />
    </el-dialog>

    <el-dialog
      :title="'寄送週報表｜' + dialogs.sendReport.shop.name"
      width="40%"
      :visible.sync="dialogs.sendReport.show">
      <el-form label-position="right">
        <el-form-item label="查詢區間">
          <el-date-picker v-model="dialogs.sendReport.dateRange"
            type="daterange" align="right" unlink-panels
            range-separator="～" start-placeholder="開始日期" end-placeholder="結束日期" >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收件人（限一組，預設為店家Email）">
          <el-input placeholder="收件人" v-model="dialogs.sendReport.recipient"></el-input>
        </el-form-item>
        <el-form-item label="密件副本（多組請以逗號分隔）">
          <el-input placeholder="密件副本" v-model="dialogs.sendReport.bccs"></el-input>
        </el-form-item>
      </el-form>

      <br>
      <div class="d-flex justify-content-end">
        <el-button type="danger" round @click="sendWeeklyReport">確定寄出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Table, TableColumn, Select } from "element-ui";
import { fetchShops, fetchSiAccounts, fetchRetailShops } from "./fetchData";
import { assignToSpecificSiAccount } from "./updateData";
import { updateInitializedStatus } from "./postData";
import PosUserMngmt from "src/pages/QcPos/PosUserMngmt";

import { library } from "@fortawesome/fontawesome-svg-core";
// import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas);

import { DataTables, DataTablesServer } from "vue-data-tables";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    "font-awesome-icon": FontAwesomeIcon,
    DataTables,
    DataTablesServer,
    PosUserMngmt,
    [Select.name]: Select
  },
  beforeRouteEnter(to, from, next) {
    fetchRetailShops()
      .then(res => {
        next(vm => vm.setData(res));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      tableData: [],
      filters: [
        {
          prop: ["accountId", "name", "isInitializedForSort", "siAccountName", "invoice"],
          value: ""
        }
      ],
      titles: [
        // {
        //   prop: "id",
        //   label: "商店ID"
        // },
        // {
        //   prop: "name",
        //   label: "商店名稱"
        // },
        // {
        //   prop: "siAccountName",
        //   label: "所屬SI"
        // }
        // {
        //   prop: "info",
        //   label: "Info"
        // }
      ],
      siAccounts: [],
      tableProps: {
        defaultSort: {
          prop: "accountId",
          order: "descending"
        }
      },

      dialogs: {
        qcposUsers: {
          show: false,
          shop: { id: -1, name: "" }
        },
        sendReport: {
          show: false,
          shop: { id: -1, name: "" },
          dateRange: [
            moment().add(-1, 'week').startOf('isoWeek').toDate(),
            moment().add(-1, 'week').endOf('isoWeek').toDate()
          ],
          recipient: '', bccs: ''
        }
      }
    };
  },
  created: function() {
    fetchSiAccounts()
      .then(res => {
        this.siAccounts = res.data;
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  methods: {
    setData: function(res) {
      this.tableData = res.data.map(d => {
        return {
          name: d.name,
          id: d.id,
          siAccountName: d.siAccountName ? d.siAccountName : '無',
          siAccountId: d.siAccountId,
          accountId: d.accountId,
          shopId: d.id,
          email: d.email,
          invoice: d.invoice,
          eaaAccountName: d.eaaAccountName,
          eaaAccountEmail: d.eaaAccountEmail,
          isInitialized: {
            text: d.isInitialized ? '已上線': '未上線',
            value: d.isInitialized
          },
          isInitializedForSort: d.isInitialized ? '已上線': '未上線'
        };
      });
    },
    clickInfo: function(row) {
      this.$router.push({
        path: `/retail/gaa/common/${row.id}/info`,
        query: { siAccountId: row.siAccountId, type: 'retail' }
      });
    },
    clickEdit: function(row) {
      this.$router.push({ path: `/retail/gaa/common/${row.id}/edit` });
    },
    clickDel: function() {
      console.log("del clicked!");
    },
    clickQR: function(row) {
      this.$router.push({ path: `/retail/gaa/common/${row.id}/qr` });
    },
    lineNotifySetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      this.$router.push({
        path: `/line-notify-groups?${qs}`
        // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      });
    },
    openingSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      this.$router.push({
        path: `/opening?${qs}`
        // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      });
    },
    goToOrderList(row) {
      this.$router.push({ path: `/summary/orders?shopId=${row.accountId}` });
    },

    createShop() {
      this.$router.push({ path: `/retail/gaa/business/wizard` });
    },
    selectChange(row) {
      // update si account id
      let updateData = {
        shopId: row.shopId,
        accountId: row.accountId,
        siAccountId: row.siAccountId
      };
      assignToSpecificSiAccount(updateData)
        .then(res => swal("所屬SI修改成功"))
        .catch(err => console.log(err));
    },
    clickContract(row) {
      this.$router.push({
        path: `/gaa/business/${row.accountId}/contract?businessId=${row.id}`
      });
    },

    showQcposUsers(row) {
      this.dialogs.qcposUsers.show = true;
      this.dialogs.qcposUsers.shop = row;
    },
    promotions(row) {
      this.$router.push({
        path: `/gaa/retail/common/${row.id}/promotion`
      });
    },
    showSendReportDialog(row) {
      console.log('showSendReportDialog row data', row);
      this.dialogs.sendReport.shop = row;
      this.dialogs.sendReport.recipient = row.email;
      this.dialogs.sendReport.show = true;
    },
    sendWeeklyReport() {
      this.dialogs.sendReport.show = false;

      //FIXME: Check regex??
      let recipient = this.dialogs.sendReport.recipient;
      let bccs = this.dialogs.sendReport.bccs.split(',');
      bccs = bccs.map(bcc => bcc.trim());
      console.warn(`Will send to ${recipient}, BCC to ${JSON.stringify(bccs)}`);
      let from = moment(this.dialogs.sendReport.dateRange[0]).unix();
      let to = moment(this.dialogs.sendReport.dateRange[1]).unix();

      axios.post(
        `${process.env.VUE_APP_APIHOST}/gaa/report/${this.dialogs.sendReport.shop.accountId}/send-email`,
        {
          from, to, recipient, bccs
        }
      )
      .then(response => {
        console.log('sendWeeklyReport done', response.data);
        swal("報表稍後將寄出。");
      })
      .catch(err => {
        console.error('sendWeeklyReport error', err);
      });
    },
    changeInitailizedStatus(row){
      row.isInitialized.value = !row.isInitialized.value;
      // update account_status
      updateInitializedStatus(row)
        .then(res => swal('成功'))
        .catch(err => swal('失敗'))
    }
  }
};
</script>